import React from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  isDescendantLockedPreview,
  getDescendantLockedCheckboxStyle,
} from "./nodeSelectionCheckboxStyles";

const FormNode = ({ node, nodeNumber, parentContext, nodeType, onNavigate, checkboxState, disabled = false, showCheckbox = true, showHeading = null, checkboxLabelColor = null, isRevisionLocked = false }) => {
  const authUser = useSelector((state) => state.auth.user);
  const nodeHeading = `Form ${node.is_deleted ? "(Deleted)" : nodeNumber}`;
  const breadcrumbStepNumber =
    parentContext?.globalStepNumber != null
      ? parentContext.globalStepNumber
      : typeof parentContext?.stepIndex === "number"
        ? parentContext.stepIndex + 1
        : "";

  // Determine checkbox state for this node
  const isCurrent = checkboxState?.currentNodeId === node.tree_node_id &&
    (checkboxState?.currentNodeType === 'form' ||
      checkboxState?.currentNodeType === nodeType);
  const isSourceForm = checkboxState?.sourceNodeId === node.tree_node_id ||
    checkboxState?.sourceNodeId === (node.detail?.form_tree_node_id || node.tree_node_id);
  const isChecked = isCurrent || checkboxState?.allChildrenChecked || isSourceForm;
  const isDisabled = disabled || (checkboxState?.allChildrenDisabled && !isCurrent) || (isRevisionLocked && isRevisionLocked.lock && isRevisionLocked.lock.user_id !== authUser?.id);
  const isDescendantLocked = isDescendantLockedPreview(
    checkboxState,
    isCurrent,
    isChecked,
    isSourceForm,
  );

  return (
    <div key={node.tree_node_id} style={{ marginTop: showCheckbox ? "20px" : "30px" }}>
      {/* Show heading - use showHeading if provided, otherwise fall back to showCheckbox */}
      {(showHeading !== null ? showHeading : showCheckbox) && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "6px",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            {showCheckbox && (
              <div style={{ position: "relative", display: "inline-block" }}>
                {isDescendantLocked ? (
                  <input
                    type="checkbox"
                    checked={isChecked}
                    disabled
                    readOnly
                    tabIndex={-1}
                    aria-readonly="true"
                    onChange={() => {}}
                    style={getDescendantLockedCheckboxStyle()}
                  />
                ) : (
                <input
                  type="checkbox"
                  checked={isChecked}
                  disabled={isDisabled}
                  onChange={() => {
                    // Prevent action for source form being moved
                    if (isSourceForm) {
                      return;
                    }
                    if (!isDisabled && onNavigate) {
                      onNavigate(nodeType || "form", node, { ...parentContext, nodeNumber });
                    }
                  }}
                  style={{
                    cursor: isDisabled ? "not-allowed" : (isSourceForm ? "not-allowed" : "pointer"),
                    accentColor: isSourceForm ? "rgb(68, 68, 68)" : undefined,
                    backgroundColor: isSourceForm ? "rgb(68, 68, 68)" : undefined,
                  }}
                />
                )}
                {/* Red cross icon overlay - shown when disabled and hovering */}
                {isDisabled && !isDescendantLocked && (
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      opacity: 0,
                      transition: "opacity 0.2s ease-in-out",
                      pointerEvents: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "100%",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.opacity = "1";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.opacity = "0";
                    }}
                    className="checkbox-hover-overlay"
                  >
                    <FontAwesomeIcon
                      icon={faTimes}
                      size="sm"
                      color="red"
                      style={{
                        filter: "drop-shadow(0 0 1px rgba(255,255,255,0.8))",
                      }}
                    />
                  </div>
                )}
              </div>
            )}
            <h2
              onClick={() => {
                // Prevent action for source form being moved
                if (isSourceForm) {
                  return;
                }
                if (!isDisabled && showCheckbox && onNavigate) {
                  onNavigate(nodeType || "form", node, { ...parentContext, nodeNumber });
                }
              }}
              style={{
                fontSize: "20px",
                margin: 0,
                fontWeight: isDescendantLocked ? 700 : undefined,
                cursor: isSourceForm ? "not-allowed" : ((!isDisabled && showCheckbox) ? "pointer" : "default"),
                color: isDescendantLocked ? "#111" : showCheckbox ? (checkboxLabelColor || undefined) : undefined,
                userSelect: "none"
              }}
            >{nodeHeading}</h2>
          </div>

          <div
            style={{
              color: "#888",
              fontSize: "14px",
              fontWeight: "normal",
            }}
          >
            {!node.is_deleted &&
              (parentContext?.auditSubstepBreadcrumbFull ? (
                <>{parentContext.auditSubstepBreadcrumbFull}</>
              ) : (
                <>
                  Section {parentContext.sectionIndex + 1} &gt; Step{" "}
                  {breadcrumbStepNumber}
                  {parentContext.substepLetter && (
                    <> &gt; Substep {breadcrumbStepNumber}{parentContext.substepLetter}</>
                  )}
                </>
              ))}
          </div>
        </div>
      )}
      <div>{node.detail?.short_description}</div>
    </div>
  );
};

export default FormNode;

